import { ChevronLeftSmall } from 'ui/icons/navigation/ChevronLeftSmall';
import { colors } from 'ui/theme/colors';
import {
  InboxHeader,
  InboxLine,
  InboxImage,
  InboxSubtitle,
  InboxText,
  InboxTitle,
} from './ContentPreviewInApp.styled';
import { InboxLineSkeleton } from './InboxLineSkeleton';
import type { TemplateDiffContentInApp } from '../../../types';

type PreviewInboxProps = {
  inboxMetadata: TemplateDiffContentInApp['inboxMetadata'];
};

/**
 * **NOTE** The component in this file is a direct copy of the `InboxPreview` component found at:
 * `src/modules/templateEditor/EditInApp/preview/InboxPreview.tsx.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does not fetch its data from grapqhl, a necessity for the templateEdit preview.
 */
export const PreviewInbox = ({ inboxMetadata }: PreviewInboxProps) => {
  return (
    <>
      <InboxHeader>
        <ChevronLeftSmall height={24} width={24} color={colors.textSecondary} />
        Inbox
      </InboxHeader>
      <InboxLine>
        {inboxMetadata?.icon && (
          <div>
            <InboxImage data-test="template-diff-in-app-inbox-icon" src={inboxMetadata.icon} />
          </div>
        )}
        <InboxText>
          <div>
            <InboxTitle data-test="template-diff-in-app-inbox-title">
              {inboxMetadata?.title}
            </InboxTitle>
            {inboxMetadata?.subtitle && (
              <InboxSubtitle data-test="template-diff-in-app-inbox-subtitle">
                {inboxMetadata.subtitle}
              </InboxSubtitle>
            )}
          </div>
          <InboxSubtitle>2 min ago</InboxSubtitle>
        </InboxText>
      </InboxLine>
      <InboxLineSkeleton />
      <InboxLineSkeleton />
      <InboxLineSkeleton />
      <InboxLineSkeleton />
    </>
  );
};
